import { AuthProvider } from 'contexts/AuthContext'
import { Suspense } from 'react'
import {  Route, createBrowserRouter, createRoutesFromElements, RouterProvider, Outlet } from 'react-router-dom'
import PageLoading from 'components/PageLoading'
import RequireAuth from 'contexts/RequireAuth'
import BarrierRoutes from './BarrierRoutes'
import MainRoutes from './MainRoutes'
import AssuranceScorecardRoutes from './AssuranceScorecard'
import ProcessSafetyRoutes from './ProcessSafetyRoutes'
import PageNotFound from 'pages/PageNotFound'
import ErrorBoundary from 'components/common/ErrorBoundary'
import AVPPermissionsRoutes from './AVPPermissions'


const AppLayout = () => {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <RequireAuth>
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </RequireAuth>
      </AuthProvider>
    </ErrorBoundary>
  )
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppLayout />}>
      {MainRoutes}
      {BarrierRoutes}
      {ProcessSafetyRoutes}
      {AssuranceScorecardRoutes}
      {AVPPermissionsRoutes}
      <Route path='*' element={<PageNotFound />} />
    </Route>
  )
);

const routes = () => {
  return (
    <RouterProvider router={router} />
  )
}

export default routes
